/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Title_LeadInputs */

const en_how_page_title_lead = /** @type {(inputs: How_Page_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From a free hour`)
};

const pl_how_page_title_lead = /** @type {(inputs: How_Page_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od wolnej godziny`)
};

/**
* | output |
* | --- |
* | "From a free hour" |
*
* @param {How_Page_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_title_lead = /** @type {((inputs?: How_Page_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_title_lead(inputs)
	return en_how_page_title_lead(inputs)
});